import { foldersKeys } from '@core/react-query/features/folders'
import { taskTemplateKeys } from '../taskTemplateKeys'
import { RequestTypes } from '../requestTypes'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'

export const useUnarchiveTaskTemplate = (
  options?: UseMutationOptions<
    Response,
    RequestErrorType,
    RequestTypes['unarchiveTaskTemplate']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...taskTemplateKeys.unarchiveTaskTemplate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: taskTemplateKeys._def })
      queryClient.invalidateQueries({ queryKey: foldersKeys._def })
    },
    ...options,
  })
}
